import type { Schema } from "@ng-org/shex-orm";

/**
 * =============================================================================
 * festipodShapesSchema: Schema for festipodShapes
 * =============================================================================
 */
export const festipodShapesSchema = {
  "http://festipod.org/Event": {
    iri: "http://festipod.org/Event",
    predicates: [
      {
        dataTypes: [
          {
            valType: "iri",
            literals: ["http://festipod.org/Event"],
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        readablePredicate: "@type",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/title",
        readablePredicate: "title",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/description",
        readablePredicate: "description",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/date",
        readablePredicate: "date",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/location",
        readablePredicate: "location",
      },
      {
        dataTypes: [
          {
            valType: "number",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/distance",
        readablePredicate: "distance",
      },
      {
        dataTypes: [
          {
            valType: "number",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/participantCount",
        readablePredicate: "participantCount",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/coverImage",
        readablePredicate: "coverImage",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/inbox",
        readablePredicate: "inbox",
      },
    ],
  },
  "http://festipod.org/UserProfile": {
    iri: "http://festipod.org/UserProfile",
    predicates: [
      {
        dataTypes: [
          {
            valType: "iri",
            literals: ["http://festipod.org/UserProfile"],
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        readablePredicate: "@type",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/name",
        readablePredicate: "name",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/initials",
        readablePredicate: "initials",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/username",
        readablePredicate: "username",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/role",
        readablePredicate: "role",
      },
      {
        dataTypes: [
          {
            valType: "boolean",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/isPublic",
        readablePredicate: "isPublic",
      },
    ],
  },
  "http://festipod.org/Participation": {
    iri: "http://festipod.org/Participation",
    predicates: [
      {
        dataTypes: [
          {
            valType: "iri",
            literals: ["http://festipod.org/Participation"],
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        readablePredicate: "@type",
      },
      {
        dataTypes: [
          {
            valType: "iri",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/event",
        readablePredicate: "event",
      },
      {
        dataTypes: [
          {
            valType: "iri",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/user",
        readablePredicate: "user",
      },
      {
        dataTypes: [
          {
            valType: "boolean",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/isConfirmed",
        readablePredicate: "isConfirmed",
      },
    ],
  },
  "http://festipod.org/MeetingPoint": {
    iri: "http://festipod.org/MeetingPoint",
    predicates: [
      {
        dataTypes: [
          {
            valType: "iri",
            literals: ["http://festipod.org/MeetingPoint"],
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        readablePredicate: "@type",
      },
      {
        dataTypes: [
          {
            valType: "iri",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/event",
        readablePredicate: "event",
      },
      {
        dataTypes: [
          {
            valType: "iri",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/host",
        readablePredicate: "host",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/title",
        readablePredicate: "title",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/description",
        readablePredicate: "description",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/place",
        readablePredicate: "place",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/time",
        readablePredicate: "time",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/inbox",
        readablePredicate: "inbox",
      },
    ],
  },
  "http://festipod.org/Notification": {
    iri: "http://festipod.org/Notification",
    predicates: [
      {
        dataTypes: [
          {
            valType: "iri",
            literals: ["http://festipod.org/Notification"],
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
        readablePredicate: "@type",
      },
      {
        dataTypes: [
          {
            valType: "iri",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/recipient",
        readablePredicate: "recipient",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/type",
        readablePredicate: "type",
      },
      {
        dataTypes: [
          {
            valType: "iri",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/ref",
        readablePredicate: "ref",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 0,
        iri: "http://festipod.org/payload",
        readablePredicate: "payload",
      },
      {
        dataTypes: [
          {
            valType: "string",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/timestamp",
        readablePredicate: "timestamp",
      },
      {
        dataTypes: [
          {
            valType: "boolean",
          },
        ],
        maxCardinality: 1,
        minCardinality: 1,
        iri: "http://festipod.org/isRead",
        readablePredicate: "isRead",
      },
    ],
  },
} as const satisfies Schema;
